import { createTheme } from '@mui/material/styles';
import { theme } from 'FrontRoyalMaterialUiForm';

// How far a tooltip sits from the element it describes. A string, because sx reads a bare number as
// a count of theme spacing units, which would make this 48px.
const TOOLTIP_OFFSET = '6px';

/*
    The shared theme, with the tooltip gap narrowed for this page only.

    MUI stands a tooltip 14px off its element, which reads as belonging to nothing in particular.
    This page has tooltips on small icon buttons packed into rows, where that gap is too wide to
    read as attached. It is not narrowed in the shared theme, because an `arrow` tooltip pushes its
    arrow out with a negative margin of roughly 8px, and pages that use one would end up with the
    arrow tip touching its trigger. No tooltip on this page uses `arrow`.

    The selectors mirror the ones MUI sets the 14px with, which read the placement off the popper
    rather than off the tooltip's own class:

        .MuiTooltip-popper[data-popper-placement*="top"] .<tooltip class>

    Matching on the tooltip class alone is a weaker selector and loses, so the margin would stay at
    14px however it was written.
*/
export const streamEditorTheme = createTheme(theme, {
    components: {
        MuiTooltip: {
            defaultProps: {
                slotProps: {
                    tooltip: {
                        sx: {
                            '.MuiTooltip-popper[data-popper-placement*="top"] &': {
                                marginBottom: TOOLTIP_OFFSET,
                            },
                            '.MuiTooltip-popper[data-popper-placement*="bottom"] &': {
                                marginTop: TOOLTIP_OFFSET,
                            },
                            '.MuiTooltip-popper[data-popper-placement*="left"] &': {
                                marginRight: TOOLTIP_OFFSET,
                            },
                            '.MuiTooltip-popper[data-popper-placement*="right"] &': {
                                marginLeft: TOOLTIP_OFFSET,
                            },
                        },
                    },
                },
            },
        },
    },
});
